import { useEffect, useMemo } from "react"
import { useFormContext } from "react-hook-form";
import Fein from "../../../../gdk/Fein";
import { classes } from "../../../../../util/style-utils";
import useCobrandedAgency from "../../../hooks/useCobrandedAgency";

export default function ParentAgencyInformation() {
    const { register, setValue, watch, formState: { errors }, control } = useFormContext();
    const { isCobrandedAgency } = useCobrandedAgency();

    const watchAffiliatedWithTop100 = watch("affiliatedWithTop100");
    const watchFirmNetworkOrAggregator = watch("firmNetworkOrAggregator");
    const watchFirmNetworkAggregatorCommissionPayments = watch("firmNetworkAggregatorCommissionPayments");
    const watchAgencyCommissionPayments = watch("agencyCommissionPayments");

    const showParentAgencyInformation = useMemo(() => {
        // Always show for cobranded agencies (will be disabled/pre-filled from backend)
        if (isCobrandedAgency) {
            return true;
        }

        if (watchAffiliatedWithTop100 === "false" && watchAgencyCommissionPayments === "false") {
            return true;
        }

        if (
            watchAffiliatedWithTop100 === "true" &&
            watchFirmNetworkOrAggregator &&
            watchFirmNetworkAggregatorCommissionPayments === "false" &&
            watchAgencyCommissionPayments === "false"
        ) {
            return true;
        }
    }, [
        isCobrandedAgency,
        watchAffiliatedWithTop100,
        watchFirmNetworkOrAggregator,
        watchFirmNetworkAggregatorCommissionPayments,
        watchAgencyCommissionPayments
    ]);

    useEffect(() => {
        // Don't clear values for cobranded agencies
        if (!showParentAgencyInformation && !isCobrandedAgency) {
            setValue("parentAgencyName", "");
            setValue("parentAgencyFein", "");
            setValue("parentAgencyEmailAddress", "");
        }
    }, [showParentAgencyInformation, setValue, isCobrandedAgency]);

    return <>
        {showParentAgencyInformation &&
            <>
                <div className="flex-row">
                    <div className={classes("form-field", errors.parentAgencyName && "form-field--error")}>
                        <label htmlFor="parent-agency-name" className="text">
                            Parent Agency Name{/*
                            */}<span className='required'>*</span>
                        </label>
                        <input
                            id="parent-agency-name"
                            type="text"
                            {...register("parentAgencyName")}
                            disabled={isCobrandedAgency}
                        />
                        {errors.parentAgencyName &&
                            <span className="form-message">{errors.parentAgencyName.message}</span>
                        }
                    </div>

                    <Fein trackingId="PrincipalFlow:AgencyOfficeInformation:ParentAgencyInformation:ParentAgencyFein"
                        control={control}
                        name="parentAgencyFein"
                        label={<>
                            Parent Agency FEIN{/*
                            */}<span className='required'>*</span>
                        </>}
                        disabled={isCobrandedAgency}
                    />
                </div>

                <div className={classes("form-field", errors.parentAgencyEmailAddress && "form-field--error")}>
                    <label htmlFor="parent-agency-email-address" className="text">
                        Parent Agency Email Address{/*
                        */}<span className='required'>*</span>
                    </label>
                    <input
                        id="parent-agency-email-address"
                        type="email"
                        {...register("parentAgencyEmailAddress")}
                        disabled={isCobrandedAgency}
                    />
                    {errors.parentAgencyEmailAddress &&
                        <span className="form-message">{errors.parentAgencyEmailAddress.message}</span>
                    }
                </div>
            </>
        }
    </>
}